export default "__VITE_ASSET__DEvCHEyp__"